/**
 * @fileoverview GET handler for the "/engagement/landing_pages/select" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPagesSelect } from "./constants";
import type { GetLandingPageNamesForSelectParams, LandingPageNamesForSelectResult } from "./types";

export const getLandingPageNamesForSelect = reactQueryFetcherAdapter(
  engagementLandingPagesSelect,
  (signal: AbortSignal, params: GetLandingPageNamesForSelectParams): Promise<LandingPageNamesForSelectResult> => {
    return fetch(`/engagement/landing_pages/select`, "GET", params, { signal });
  }
);
